const CHUNK_RELOAD_STORAGE_KEY = 'aimason:chunk-reload-at'
const CHUNK_RELOAD_COOLDOWN_MS = 15000

function errorText(error) {
  if (!error) return ''
  if (typeof error === 'string') return error
  return [error.name, error.code, error.message].filter(Boolean).join(' ')
}

function isChunkLoadError(error) {
  const text = errorText(error)
  return /ChunkLoadError|CSS_CHUNK_LOAD_FAILED|Loading (?:CSS )?chunk(?: [\w-]+)? failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(text)
}

function isHashedChunkAsset(url) {
  return /(?:^|\/)static\/(?:js|css)\/[^?#]+\.[a-f0-9]{6,}\.(?:js|css)(?:[?#].*)?$/i.test(String(url || ''))
}

function installChunkLoadRecovery(router, windowRef) {
  if (!router || typeof router.onError !== 'function' || !windowRef) return null

  let reloading = false

  const recover = (error) => {
    if (reloading || !isChunkLoadError(error)) return false

    const now = Date.now()
    let lastReloadAt = 0
    try {
      lastReloadAt = Number(windowRef.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) || 0
    } catch (storageError) {
      // sessionStorage 不可用时仍允许本次运行时恢复一次。
    }

    if (now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) return false

    try {
      windowRef.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now))
    } catch (storageError) {
      // 记录失败不应阻断页面恢复。
    }

    reloading = true
    windowRef.location.reload()
    return true
  }

  const onUnhandledRejection = (event) => {
    if (recover(event && event.reason) && event && typeof event.preventDefault === 'function') {
      event.preventDefault()
    }
  }

  const onResourceError = (event) => {
    const target = event && event.target
    const assetUrl = target && (target.src || target.href)
    if (isHashedChunkAsset(assetUrl)) {
      recover(new Error(`ChunkLoadError: ${assetUrl}`))
    }
  }

  router.onError(recover)
  if (typeof windowRef.addEventListener === 'function') {
    windowRef.addEventListener('unhandledrejection', onUnhandledRejection)
    windowRef.addEventListener('error', onResourceError, true)
  }

  return { recover, onUnhandledRejection, onResourceError }
}

module.exports = {
  CHUNK_RELOAD_COOLDOWN_MS,
  CHUNK_RELOAD_STORAGE_KEY,
  installChunkLoadRecovery,
  isChunkLoadError,
  isHashedChunkAsset
}
